import { Component, OnInit, OnChanges, ViewContainerRef, Input } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';

import { UpdatePoliticallyExposedInfoComponent } from 'app/entities/monitoring/actual/politicallyexposed/politicallyexposedinfo/updatepoliticallyexposedinfo/update-politically-exposed-info.component';
import { PoliticallyExposed } from 'app/shared/models/politically-exposed.model';
import { PoliticallyExposedService } from 'app/entities/monitoring/actual/politicallyexposed/politically-exposed.service';
import { EntityMonitoringService } from 'app/entities/monitoring/entity-monitoring.service';

import { EntityType, EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  selector: 'pep-info',
  templateUrl: './politically-exposed-info.component.html',
  styleUrls: ['./politically-exposed-info.component.css']
})

/**
 * Component to display the monitoring Politically Exposed data for the entity.
 */
export class PoliticallyExposedInfoComponent implements OnInit, OnChanges {
  @Input() entityIdDetails: EntityIdDetails;

  public id: number;

  dialogRef: MdDialogRef<any>;
  politicallyExposedInfoData: string;
  // Here -1 value is taken to display the spinned until the data is loaded.
  politicallyExposedInfoDataCount: number = -1;
  politicallyExposedInfoLoaded = false;
  matchResolutions: ApplicationValue[];

  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    private politicallyExposedInfoService: PoliticallyExposedService,
    private entityMonitoringService: EntityMonitoringService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService,
    private warmUpService: WarmUpService) { }

  ngOnInit() {
    this.ngOnChanges();
    this.setUpMatchResolutions(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.SANCTION_MATCH_RESOLUTION));
  }

  ngOnChanges() {
    if (this.entityIdDetails && this.entityIdDetails.entityId) {
      this.id = this.entityIdDetails.entityId;
      this.getPoliticallyExposedInfoDesc();
    }
  }

  // Get Monitoring Elaboration Text Description..
  getPoliticallyExposedInfoDesc() {
    this.politicallyExposedInfoLoaded = false;
    this.politicallyExposedInfoData = "";
    this.entityMonitoringService.getPepHistory(this.id).subscribe(response => {
      const list = (response && response.suggestionList) || [];
      this.politicallyExposedInfoDataCount = list.filter(r => this.isPositiveResolution(r && r.matchResolution)).length;
      this.politicallyExposedInfoLoaded = true;
    }, _err => {
      this.politicallyExposedInfoDataCount = 0;
      this.politicallyExposedInfoLoaded = true;
    });
  }

  setUpMatchResolutions(dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(response => {
        this.warmUpService.setApplicationTypeInLS(response);
        this.matchResolutions = response.values;
        if (this.id) {
          this.getPoliticallyExposedInfoDesc();
        }
      });
    } else {
      this.matchResolutions = dropDownValues;
    }
  }

  getMatchStatus(matchId) {
    if (this.matchResolutions) {
      const match = this.matchResolutions.find(matchResolution => matchResolution.id === matchId);
      if (match) {
        return match.name;
      }
    }
    return 'Probable';
  }

  isPositiveResolution(matchId): boolean {
    const name = this.getMatchStatus(matchId);
    return /true/i.test(name);
  }

  // Open dialog having text editor to update Monitoring Elaboration text.
  openPoliticallyExposedInfoUpdateDialog() {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(UpdatePoliticallyExposedInfoComponent, config);
    this.dialogRef.componentInstance.argId = this.id;
    this.dialogRef.componentInstance.argEntityType = this.entityIdDetails.entityType;
    this.dialogRef.componentInstance.entityTypeId = this.entityIdDetails.entityId;
    this.dialogRef.componentInstance.argPoliticallyExposedInfoDetailsData = this.politicallyExposedInfoData;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      this.getPoliticallyExposedInfoDesc();
      this.politicallyExposedInfoService.addPepMatchEvent('AddedPepMatch');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/politicallyexposed/politicallyexposedinfo/politically-exposed-info.component.ts